<template>
  <div class="main-content-container">
    <app-header :step="1" />
    <div class="step">
      <div class="step-header">
        <h3>{{ $t("steps.step1") }}</h3>
      </div>
      <first-step-form />
      <result-info :bikesCount="bikesCount" :bestSellers="areBestsellers" />
      <div class="step-actions">
        <a
          class="btn-primary"
          @click="goToSecondStep"
          :class="{ disabled: filters.age >= 12 && filters.gender == null }"
        >
          {{ $t("buttons.next") }}
        </a>
      </div>
      <div class="step-summary" v-if="bikesReady && exampleBikesIds.length">
        <bike-tile-list
          v-if="bikesReady && exampleBikesIds.length"
          :bikesIds="exampleBikesIds"
          :bikesCount="bikesCount"
        />
        <span @click="goToAllResults" class="step-summary-action-btn">
          {{ $t("buttons.seeAll") }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";

// components
import AppHeader from "@/components/App/AppHeader";
import BikeTileList from "@/components/Bikes/BikeTileList";
import FirstStepForm from "@/components/Forms/FirstStepForm";
import ResultInfo from "@/components/App/ResultInfo";

// css
import "./Step.scss";

export default {
  name: "FirstStep",
  data() {
    return {
      bikesCount: 0,
      bikesIds: null,
      exampleBikesIds: null,
      bikesReady: false,
      timeoutId: null,
      areBestsellers: false,
    };
  },
  computed: {
    ...mapFields(["filters"]),
  },
  watch: {
    // deep watch filters object in store.state
    filters: {
      deep: true,
      async handler() {
        // clear previous call
        if (this.timeoutId != null) {
          window.clearTimeout(this.timeoutId);
        }

        // wait 1 second and get bikes with current filters.
        // this call will be canceled if during 1 second filters will be changed again
        this.timeoutId = window.setTimeout(() => {
          this.getBikesIds().then(() => {
            this.setExampleBikes();
          });
        }, 1000);
      },
    },
  },
  methods: {
    goToThirdStep: function () {
      this.$router.push({ name: "thirdStep" });
    },
    goToAllResults: function () {
      this.$router.push({ name: "thirdStepAllResults" });
    },
    setExampleBikes: function () {
      this.exampleBikesIds = this.bikesIds.filter((bike, idx) => idx <= 8);
    },
    getBestsellerBikesIds: function () {
      this.$store.dispatch("getBestsellerBikesIds").then((res) => {
        this.bikesCount = res.bikesCount;
        this.bikesIds = res.bikesIds;
        this.bikesReady = true;
        this.setExampleBikes();
      });
    },
    getBikesIds: async function () {
      await this.$store.dispatch("getBikesIds").then((res) => {
        if (res.bikesCount === 0 && !res.bikesIds.length) {
          this.getBestsellerBikesIds();
          this.areBestsellers = true;
        } else {
          this.bikesCount = res.availableCount;
          this.bikesIds = res.bikesIds;
          this.setExampleBikes();
          this.areBestsellers = false;
          this.bikesReady = true;
        }
      });
    },
    goToSecondStep: function () {
      if (this.filters.age < 12) {
        this.$router.push({ name: "secondStep" });
      } else {
        if (this.filters.gender != null) {
          this.$router.push({ name: "secondStep" });
        }
      }
    },
  },
  async mounted() {
    await this.getBikesIds();
  },
  components: {
    AppHeader,
    BikeTileList,
    FirstStepForm,
    ResultInfo,
  },
};
</script>
